import React from 'react';

const Footer = () => {
    return (
        <div>
            <p><small>Copyright Protected</small></p>
        </div>
    );
};

export default Footer;